import { AgreementService } from '@appStore/selfservice/services/agreement.service';
import { FormsService } from '@appStore/selfservice/services/forms.service';
import { BookingsService } from '@appStore/selfservice/services/bookings.service';

export const services: any[] = [
    AgreementService, FormsService, BookingsService
];

export * from '@appStore/selfservice/services/agreement.service';
export * from '@appStore/selfservice/services/forms.service';
export * from '@appStore/selfservice/services/bookings.service';